define('plugin/package/view/PackageCollectionView',['require','lib/view/BaseCollectionView','plugin/package/view/PackageItemView','plugin/package/view/PackageEmptyView'],function (require) {

    var Parent = require('lib/view/BaseCollectionView');
    var PackageItemView = require('plugin/package/view/PackageItemView');
    var PackageEmptyView = require('plugin/package/view/PackageEmptyView');

    /**
     * Package collection view
     *
     * @class PackageCollectionView
     */
    return Parent.extend({

        childView: PackageItemView,
        emptyView: PackageEmptyView,
        childViewOptions: function () {
            return {
                serviceCollection: this.getOption('serviceCollection'),
                productCollection: this.getOption('productCollection'),
                attributeCollection: this.getOption('attributeCollection')
            };
        },
        collectionEvents: {
            sync: 'render'
        },
        _pageId: 'package',

        initialize: function () {
            this.listenTo(this.getOption('serviceCollection'), 'sync', this.safeRender);
            this.listenTo(this.getOption('productCollection'), 'sync', this.safeRender);
            this.listenTo(this.getOption('attributeCollection'), 'sync', this.safeRender);

            Parent.prototype.initialize.apply(this, arguments);
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        onDomRefresh: function () {
            Parent.prototype.onDomRefresh.apply(this);
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'packages'
            });
        },

        filter: function (child, index, collection) {
            var filter = this.getOption('filterData');

            if (filter && (filter.services || filter.products)) {
                var filterServices = filter.services || [];
                var filterProducts = filter.products || [];

                var childServices = child.get('services');
                childServices = childServices ? childServices.map(function (service) { return '' + service.service_id; }) : [];

                var childProducts = child.get('products');
                var childProductIds = childProducts ? childProducts.map(function (model) { return '' + model.product_id; }) : [];

                var childPaidAttributes = child.get('paid_attributes');
                var childPaidAttributeIds = childPaidAttributes ? childPaidAttributes.map(function (model) { return '' + model.product_id; }) : [];

                return _.intersection(childServices, filterServices).length > 0 
                    || _.intersection(childProductIds, filterProducts).length > 0
                    || _.intersection(childPaidAttributeIds, filterProducts).length > 0
            }

            if (filter && filter.id) {
                return child.get('id') == filter.id;
            }

            return true;
        }

    });

});
